/* eslint-disable camelcase */
 
import { fetchList   ,   fetchCoachList ,fetchUserProfileList} from '@/api/sysRole'
const state = {
  list: [],
  items: [],

  coachList: [],
  studentList: [],
  userProfileList : [] ,
}

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list
  },
  SET_COACHLIST: (state, list) => {
    state.coachList = list
  },
  SET_ITEMS: (state, items) => {
    state.items = items
  },
  SET_STUDENTLIST: (state, list) => {
    state.studentList = list
  },

  SET_USERPROFILELIST: (state, list) => {
    state.userProfileList = list
  },

}

const actions = {
  list({ commit }) {
    return new Promise((resolve, reject) => 
    fetchList({page: 0 , limit:0 }).then(reponse => {
      commit('SET_LIST', reponse.data.items)
      resolve(reponse.data)
    }).catch(err => {
      console.log('sysRole', err)
    }))
  },

  coachlist({ commit }) {
    return new Promise((resolve, reject) => 
    fetchCoachList({page: 0 , limit:0   }).then(reponse => {
      commit('SET_COACHLIST', reponse.data.items)
      resolve(reponse.data)
    }).catch(err => {
      console.log('sysRole', err)
    }))
  },

  studentlist({ commit }) {
    return new Promise((resolve, reject) => 
    fetchList({page: 0 , limit:0 , SearchKeyWord: 'student' }).then(reponse => {
      commit('SET_STUDENTLIST', reponse.data.items)
      resolve(reponse.data)
    }).catch(err => {
      console.log('sysRole', err)
    }))
  },
 
  
  userprofileList({ commit }) {
    return new Promise((resolve, reject) => 
    fetchUserProfileList({page: 0 , limit:0  }).then(reponse => {
      commit('SET_USERPROFILELIST', reponse.data.items)
      resolve(reponse.data)
    }).catch(err => {
      console.log('sysRole', err)
    }))
  },


  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
